<script>
import BarList from '../components/bar-list'
import TabpreAddForm from './tabpre-add-form'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import { SysVars } from '../main'

export default {
    props: {
        tabpre: Object
    },

    data () {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            tabelasList: [],
            isView: false,
            indexEditing: null,
            showInserirProduto: false,
        }
    },

    computed: {
        possuiPermissao: function () {
            if (SysVars.usaIntegracao) {
              return false;
            }
            return SysVars.appNFe || SysVars.appERP || SysVars.appLoja || (SysVars.usuarioAdministrador && SysVars.appForcaVendas) 
        },

        tabpreItens: function () {
            return this.$store.getters.getTabpreItens
        },

        tpTabela: function () {
            return this.tabpre.tptabela
        },

        permiteAlteracao: function () {
            return this.tabpre.tptabela == 'P'
        }
    },

    watch: {

    },

    methods: {
        isExist : function(coditem){            
            for (var i = 0; i < this.tabpreItens.length; i++){                
                if( this.tabpreItens[i].coditem === coditem){
                return true
                }
            }
            return false
        },
        closeForm () {
            this.$emit('closeform')
        },

        handleAddItem(){
            if (!this.possuiPermissao) {
                this.$erpToastError('Usuário sem permissão.')
                return
            }
            this.showInserirProduto = true
        },

        handleEditItem (index) {
            if (!this.possuiPermissao) {
                this.$erpToastError('Usuário sem permissão.')
                return
            }
            //HABILITA ITEM PARA ALTERÇÃO
            this.indexEditing = index
            this.$nextTick(function () {                
                this.$refs.vlr[0].focus();
            })
        },

        handleDeleteVariavel (index) {            
            if (!this.possuiPermissao) {
                this.$erpToastError('Usuário sem permissão.')
                return
            }
            this.apiDelete(index);
            
        },

        handleGravaAlteracaoItem (index) {
            //GRAVA ITEM ALTERADO
            if (this.tabpreItens[index].vlr < 0) {
                this.$erpToastError('Valor não permitido')
                this.$refs.vlr.focus()
            }
            let itens = []
            itens.push(this.tabpreItens[index])
            this.apiItens(itens, true)
            this.indexEditing = null
        },

        handleSalvarItens (itens) {      
                        
            let adicionados = [];
            let itensAdd = [];
            
            for (var i = 0; i < itens.length; i++){
                if (this.isExist(itens[i].coditem)) {
                    adicionados.push(itens[i].codigo);
                } else {
                    itensAdd.push(itens[i]);
                }
            }                       
            
            if (adicionados.length > 0) {
                this.$erpToastError('Produtos existentes: ' + adicionados.join(", "));
            }
            

            if (itensAdd.length == 0) {                                
                return
            } else 
            {                           
                this.apiItens(itensAdd)
                this.$refs.addList.focus()
             }
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codigo":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadTabpreItens', { id: this.tabpre.codtabpre, filter: this.filter } )
            this.offset = ''
        },

        async apiItens (itens, edtingProduto) {
            var modulo = 'cg/tabpre/produto/'
            var sendData = { 
                tabpre: { 
                    codtabpre: this.tabpre.codtabpre, 
                    tabpreit: itens 
                } 
            }

            let update = false
            if (this.crud != SysVars.crudI) {
                update = true
            }            
            const data = await apiORDSpost(this.$store, modulo, sendData, 'post')
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                this.errmessages = {}
            }
            if (!edtingProduto) {
                this.loadData()
            }
        },

        async apiDelete (index) {
            //efetua a exclusao
            var modulo = 'cg/tabpre/produto/' + index

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()            
            this.loadData()
        },

    },

    components: {
        BarList, TabpreAddForm
    },

    created () {
        this.loadData()
    },

}

</script>

<template>
    <div>
        <div id="list"> 
            <bar-manut 
                single-entity="Produtos da Tabela de Preço" 
                :btn-delete="false"
                @closeform="closeForm">
            </bar-manut>
            <!-- <v-button label="Retornar" icon="fa-plus" @click="closeForm"></v-button> -->
            <div class="default-container nb-margin-top" style="border-top: 3px solid black">
                <label-title :title="tabpre.descricao"></label-title>
                <div class="w-100">
                    <span v-if="tabpre.texto" class="data-list">{{ tabpre.texto }}</span>
                </div>
                <div>
                    <alert v-if="tpTabela != 'P'" type="info" title="Tabela tipo acréscimo ou desconto" text="Esta tabela não possibilita inclusão de novos itens."></alert>
                    <alert v-if="tabpreItens.length == 0" type="info" title="Tabela sem produtos" text="Inclua produtos na tabela de preços."></alert>
                </div>
                <hr>
                <div class="row col" style="padding: 35px" v-if="tpTabela == 'P'">
                    <div v-if="!showInserirProduto">
                        <v-button label="Adicionar Produtos" :nb-btdef="true" title="" icon="fa-plus" @click="handleAddItem"></v-button>
                    </div>
                    <tabpre-add-form ref="addList" v-if="!isView && showInserirProduto" :params="{ items: this.tabpreItens }"
                        @additem="handleSalvarItens"></tabpre-add-form>
                </div>

                <div class="mainbox" v-for="(tabpre, index) in tabpreItens" :key="index">
                    <div class="box">
                        <div class="row align-items-center">
                            <div class="col-md-2 col-3">
                                <span class="lbl-list w-100">Código</span>
                                <span class="data-list">{{ tabpre.codigo }}</span>
                            </div>
                            <div class="col-md-4 col-6">
                                <span class="lbl-list w-100">Descrição</span>
                                <span class="data-list">{{ tabpre.descricao }}</span>
                            </div>
                            <div v-if="index != indexEditing" class="col-md-2 col-3">
                                <span class="lbl-list w-100">Preço</span>
                                <span class="data-list">{{ tabpre.vlr | formatValue(2) }}</span>
                            </div>
                            <div v-if="index != indexEditing" class="col-md-2 col-3">
                                <span class="lbl-list w-100">Preço Mínimo</span>
                                <span class="data-list">{{ tabpre.vlrmin | formatValue(2) }}</span>
                            </div>
                            <form-field ref="vlr" v-if="index == indexEditing" v-model="tabpre.vlr" type="value" col="2" :metadata="metadata.tabpreit.vlr" 
                                name="vlr" :v-errors="errors" v-validate="metadata.tabpreit.vlr.validator" @keyenter="handleGravaAlteracaoItem(index)"></form-field>
                            <form-field ref="vlrmin" v-if="index == indexEditing" v-model="tabpre.vlrmin" type="value" col="2" :metadata="metadata.tabpreit.vlrmin" 
                                name="vlrmin" :v-errors="errors" v-validate="metadata.tabpreit.vlrmin.validator" @keyenter="handleGravaAlteracaoItem(index)"></form-field>                                
                            <div v-if="permiteAlteracao" class="col-md-2 col-2">
                                <v-button v-if="indexEditing == null" :tabindex="-1" icon="fa-pencil" @click="handleEditItem(index)"></v-button>
                                <v-button v-if="indexEditing == null" :tabindex="-1" icon="fa-trash" @click="handleDeleteVariavel(tabpre.codtabpreit)"></v-button>
                                <v-button v-if="indexEditing != null" :tabindex="-1" icon="fa-check" @click="handleGravaAlteracaoItem(index)"></v-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/tabpre-itens-form.vue